import { catchError, tap, throwError } from 'rxjs';
import { inject, Injectable, signal } from '@angular/core';

import { CountriesService as CountriesApiService } from '../../../app/api/api/countries.service';
import { CountryDto } from '../../../app/api/model/countryDto';

@Injectable({ providedIn: 'root' })
export class CountriesService {
  private countriesApiService = inject(CountriesApiService);
  private countriesSignal = signal<CountryDto[]>([]);

  constructor() {
    // Load countries immediately on service initialization
    this.loadCountries();
  }

  private loadCountries() {
    this.countriesApiService
      .countriesControllerGetAllCountries()
      .pipe(
        tap((response) => {
          // Response is now properly typed as the wrapped API response
          this.countriesSignal.set(response.data || []);
        }),
        catchError((error: unknown) => {
          console.error('Error fetching countries:', error);
          this.countriesSignal.set([]);
          return throwError(() => error);
        }),
      )
      .subscribe();
  }

  getCountries() {
    return this.countriesSignal.asReadonly();
  }

  /**
   * Get country by ISO2 code
   */
  getCountryByIso2(iso2: string): CountryDto | undefined {
    const countries = this.countriesSignal();
    if (!Array.isArray(countries) || countries.length === 0) {
      return undefined;
    }
    return countries.find((c) => c.codeISO2 === iso2.toUpperCase());
  }
}
